import { PlaceActionType } from './place-action-type';

export interface CreatePlaceRequestAction {
  placeKey: string;
  type: PlaceActionType.CreatePlaceRequest;
}

export const createPlaceRequest = (
  placeKey: string,
): CreatePlaceRequestAction => ({
  placeKey,
  type: PlaceActionType.CreatePlaceRequest,
});
